<template>
  <link-lock-exemptions-list
    v-if="selectedMsp.id"
    :tier="tierType"
    :id="selectedMsp.id"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import LinkLockExemptionsList from "@/views/Common/LinkLock/Exemptions/index.vue";

import { TIER } from "@/constants";

export default {
  name: "LinkLockExemptions",
  components: {
    LinkLockExemptionsList,
  },
  data() {
    return {
      tierType: TIER.msps,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedMsp"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  created() {
    this.setPageTitle(this.$t("Link Lock"));
    this.setPageSubtitle([
      "Link Lock removes the possibility of a user clicking on a malicious link by rewriting all links in every inbound email. If a link is malicious, the user is sees a block page indicating that there is a security risk.",
    ]);
  },
};
</script>
